var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransactionAcquired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9258 13.25H17.1758L14.1758 16.25L11.1758 13.25H13.4258V2.75H14.9258V13.25ZM7.42578 10.25H4.42578C3.59328 10.25 2.92578 10.9175 2.92578 11.75V14.75C2.92578 15.5825 3.59328 16.25 4.42578 16.25H7.42578C8.25828 16.25 8.92578 15.5825 8.92578 14.75V11.75C8.92578 10.9175 8.25828 10.25 7.42578 10.25ZM5.37828 15.125L3.48078 13.2125L4.28328 12.425L5.38578 13.5425L7.57578 11.375L8.37078 12.1625L5.37828 15.125ZM7.42578 2.75H4.42578C3.59328 2.75 2.92578 3.4175 2.92578 4.25V7.25C2.92578 8.0825 3.59328 8.75 4.42578 8.75H7.42578C8.25828 8.75 8.92578 8.0825 8.92578 7.25V4.25C8.92578 3.4175 8.25828 2.75 7.42578 2.75ZM7.42578 7.25H4.42578V4.25H7.42578V7.25Z",
    fill: "#64A4A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionAcquired);
export default __webpack_public_path__ + "static/media/TransactionAcquired.9b1d3b97f1d5de3e7d8bd9744a11f501.svg";
export { ForwardRef as ReactComponent };